import { makeContextModule } from '@cian/react-utils';

export type TPhonesOpenedContext = {
  isPhonesOpened: boolean;
  setPhonesOpened: (isPhonesOpened: boolean) => void;
};

export const { Context: PhonesOpenedContext, useContext: usePhonesOpenedContext } =
  makeContextModule<TPhonesOpenedContext>({
    contextName: 'PhonesOpenedContext',
  });
